module.exports={
    url:"https://dot-guidance-prod-backend.michelin.com/v1",
    azure_image_storage_endpoint:"https://api.michelin.com/sfdc-az-img"
}
